<template>
    <div class="section2">
        <div class="tit">
            <img class="img2" :src="require(`../../assets/${language}/2-1/title_2-1.png`)" alt="">
        </div>
        <div class="people"><i>{{ formattedPeople }}</i><span>{{i18n('registered')}}</span></div>
        <div class="progress">
            <div :class="['progress-bar',{'active': firstin && people >= item.num}]" v-for="(item,i) in progress" :key="i">{{item.text}}</div>
        </div>
        <div class="box">
            <div :class="['target',{'active': firstin && people >= item.num}]" v-for="(item,i) in progress" :key="i"></div>
            <div class="line" :style="{'left': lineLeft + 'rem'}"></div>
        </div>
        <div class="reward_area">
            <img class="rewards" :src="require(`../../assets/${language}/2-1/rewards.png`)" alt="">
            <div :class="['reward_item',{'active': firstin && people >= item.num}]" v-for="(item,i) in progress" :key="i"></div>
        </div>
        <div class="wap_reward">
            <div :class="['wap_progress',{'active': firstin && people >= item.num}]" v-for="(item,i) in progress" :key="i">
                <div class="progress-bar">{{item.text}}</div>
                <img class="select_img" src="../../assets/wap/zh/2-1/select.png" alt="">
            </div>
            <img class="rewards_img" :src="require(`../../assets/wap/${language}/2-1/rewards.png`)" alt="">
            <div class="wapbox">
                <div :class="['target',{'active': firstin && people >= item.num}]" v-for="(item,i) in progress" :key="i"></div>
                <div class="line" :style="{'bottom': linebottom + 'rem'}"></div>
            </div>
        </div>
        <div :class="['ljyy',language]" @click="$emit('ljyy')">{{i18n('ljyy')}}</div>
    </div>
</template>
<script>
export default {
    props: ['language','i18n'],
    computed: {
        formattedPeople() {
            return this.displayPeople.toLocaleString();
        }
    },
    data() {
        return {
            firstin: false,
            people: 0,
            displayPeople: 0, // 当前显示的数字
            animationId: null, // 动画ID，用于取消动画
            progress: [
                {num: 50000,text: '5萬'},
                {num: 100000,text: '10萬'},
                {num: 200000,text: '20萬'},
                {num: 350000,text: '35萬'},
                {num: 600000,text: '60萬'},
                {num: 1000000,text: '100萬'},
            ], // 进度条进度
            lineLeft: -17.72, // 进度条宽度
            linebottom: -8.36 //wap端进度条
        }
    },
    methods: {
        onFirstVisit() {
            this.firstin = true;
            this.getReservationCount()
        },
        getReservationCount() {
            this.$http.get('MlbbReservation/getReservationCount').then(res => {
                if(res.code == 0) {
                    this.people = res.data.count;
                    this.animateNumber(this.people,1000);
                    this.calculateWidth(this.people)
                    this.calculateWidth2(this.people)
                }
            })
        },
        // 计算进度条宽度
        calculateWidth(people) {
            const startTime = Date.now();
            const startValue = this.lineLeft; // 从当前值开始
            let endValue = 0;
            let duration = 0;
            // 根据人数计算目标宽度（注意：这里计算的是负值，因为最大为0）
            if(people < 50000) {
                const positiveValue =  1.75 * (people / 50000);
                endValue = (-17 + positiveValue) > -15.6 ?  -15.6 : (-17 + positiveValue);
                duration = 500
            }
            else if(people >= 50000 && people < 100000) {
                // 将正值映射为负值，保持相同的比例关系
                const positiveValue = 2.35 +2.79*(people - 50000)/(100000 - 50000);
                endValue = -17.72 + positiveValue; // -17.72是初始值
                duration = 1000
            }
            else if(people >= 100000 && people < 200000) {
                const positiveValue = 2.35 +2.79 +2.79*(people - 100000)/(200000 - 100000);
                endValue = -17.72 + positiveValue;
                duration = 1500
            }
            else if(people >= 200000 && people < 350000) {
                const positiveValue = 2.35 +2.79 +2.79 +2.79*(people - 200000)/(350000 - 200000);
                endValue = -17.72 + positiveValue;
                duration = 2000
            }
            else if(people >= 350000 && people < 600000) {
                const positiveValue = 2.35 +2.79 +2.79 +2.79 +2.79*(people - 350000)/(600000 - 350000);
                endValue = -17.72 + positiveValue;
                duration = 2500
            }
            else if(people >= 600000 && people < 1000000) {
                const positiveValue =  2.35 +2.79 +2.79 +2.79 +2.79 +2.79*(people - 600000)/(1000000 - 600000);
                endValue = -17.72 + positiveValue;
                duration = 3000
            }
            else if(people >= 1000000) {
                endValue = 0; // 最大值为0
                duration = 3500
            }
            
            // 确保endValue不超过0
            endValue = Math.min(endValue, 0);
            
            // 计算总变化量
            const totalChange = endValue - startValue;
            
            const animate = () => {
                const currentTime = Date.now();
                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);
                
                // 使用缓动函数，让动画更自然
                const easeOutQuart = 1 - Math.pow(1 - progress, 4);
                
                // 更新lineLeft属性
                this.lineLeft = startValue + totalChange * easeOutQuart;
  
                if (progress < 1) {
                    requestAnimationFrame(animate);
                } else {
                    this.lineLeft = endValue; // 确保最终值准确
                }
            }
            
            // 开始动画
            animate();
        },

        // 数字递增动画方法
        animateNumber(people,duration) {
            const startTime = Date.now();
            const startValue = this.displayPeople;
            const endValue = people;
            const totalChange = endValue - startValue;
            const animate = () => {
                const currentTime = Date.now();
                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);
                // 使用缓动函数，让动画更自然
                const easeOutQuart = 1 - Math.pow(1 - progress, 4);
                this.displayPeople = Math.floor(startValue + totalChange * easeOutQuart);
                if (progress < 1) {
                    this.animationId = requestAnimationFrame(animate);
                } else {
                    this.displayPeople = endValue; // 确保最终值准确
                }
            };
            this.animationId = requestAnimationFrame(animate);
        },

        //移动端 计算进度条高度
        calculateWidth2(people) {
            const startTime = Date.now();
            const startValue = this.linebottom; // 从当前值开始
            let endValue = 0;
            let duration = 0;
            // 根据人数计算目标宽度（注意：这里计算的是负值，因为最大为0）
            if(people < 100000) {
                const positiveValue =  1.2 * people/100000;
                endValue = (-8.3 + positiveValue) > -7.4 ? -7.4 : (-8.3 + positiveValue);
                duration = 500
            }
            else if(people >= 100000 && people < 250000) {
                // 将正值映射为负值，保持相同的比例关系
                const positiveValue = 1.05 + 1.32*(people - 100000)/(250000 - 100000);
                endValue = -8.36 + positiveValue; // -17.72是初始值
                duration = 1000
            }
            else if(people >= 250000 && people < 500000) {
                const positiveValue = 1.05 + 1.32 + 1.32*(people - 250000)/(500000 - 250000);
                endValue = -8.36 + positiveValue;
                duration = 1500
            }
            else if(people >= 500000 && people < 750000) {
                const positiveValue = 1.05 + 1.32 + 1.32 + 1.32 *(people - 500000)/(750000 - 500000);
                endValue = -8.36 + positiveValue;
                duration = 2000
            }
            else if(people >= 750000 && people < 1000000) {
                const positiveValue = 1.05 + 1.32 + 1.32 + 1.32 + 1.32 *(people - 750000)/(1000000 - 750000);
                endValue = -8.36 + positiveValue;
                duration = 2500
            }
            else if(people >= 1000000 && people < 1500000) {
                const positiveValue =  1.05 + 1.32 + 1.32 + 1.32 + 1.32 + 1.32*(people - 1000000)/(1500000 - 1000000);
                endValue = -8.36 + positiveValue;
                duration = 3000
            }
            else if(people >= 1500000) {
                endValue = 0; // 最大值为0
                duration = 3500
            }
            
            // 确保endValue不超过0
            endValue = Math.min(endValue, 0);
            
            // 计算总变化量
            const totalChange = endValue - startValue;
            
            const animate = () => {
                const currentTime = Date.now();
                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);
                
                // 使用缓动函数，让动画更自然
                const easeOutQuart = 1 - Math.pow(1 - progress, 4);
                
                // 更新lineLeft属性
                this.linebottom = startValue + totalChange * easeOutQuart;
  
                if (progress < 1) {
                    requestAnimationFrame(animate);
                } else {
                    this.linebottom = endValue; // 确保最终值准确
                }
            }
            
            // 开始动画
            animate();
        }
    },
    // 组件销毁时清理动画
    beforeDestroy() {
        if (this.animationId) {
            cancelAnimationFrame(this.animationId);
        }
        if (this.widthAnimationId) {
            cancelAnimationFrame(this.widthAnimationId);
        }
    }
}
</script>
<style lang="less" scoped>
.section2 {
    width: 100%;
    height: 100%;
    background: url(../../assets/zh/2-1/bg.png) center center / cover no-repeat;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .tit {
        width: 11.42rem;
        height: 1.96rem;
        margin: 0 auto;
        background: url(../../assets/zh/2-1/tit_bg.png) center center / 100% 100% no-repeat;
        .img2 {
            width: auto;
            height: .64rem;
            margin: .85rem auto 0;
            display: block;
        }
    }
    .people {
        width: 8.51rem;
        margin: 0 auto .4rem;
        text-align: center;
        color: #eebb1e;
        font-size: .34rem;
        vertical-align: bottom;
        white-space: nowrap;
        background: url(../../assets/zh/2-1/people_bg.png) center 100%  / 100% .65rem no-repeat;
        i {
            font-family: Alibaba-PuHuiTi, Alibaba-PuHuiTi;
            height: .98rem;
            font-style: italic;
            color: #fff;
            font-weight: 700;
            font-size: .98rem;
            margin-right: .2rem;
            display: inline-block;
            text-shadow: -1px 0 #333, 0 1px #333, 1px 0 #333, 0 -1px #333;
        }
        span {
            font-size: .38rem;
            color: #FEF8A7;
            font-weight: 700;
        }
    }
    .progress {
        width: 19rem;
        margin: 0 auto 0.2rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 1.8rem 0 2.15rem;
        position: relative;
    }
    .progress-bar {
        z-index: 10;
        width: 1.25rem;
        height: .59rem;
        line-height: .59rem;
        text-align: center;
        background-position: 0 0;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-image: url(../../assets/zh/2-1/numbg.png);
        color: #B04B30;
        font-size: .3rem;
        font-weight: 700;
        &.active {
            &:nth-child(1) {
                animation: showbox 1.2s forwards;
                animation-delay: .2;
            }
            &:nth-child(2) {
                animation: showbox 1.2s forwards;
                animation-delay: .4s;
            }
            &:nth-child(3) {
                animation: showbox 1.2s forwards;
                animation-delay: .6s;
            }
            &:nth-child(4) {
                animation: showbox 1.2s forwards;
                animation-delay: .8s;
            }
            &:nth-child(5) {
                animation: showbox 1.2s forwards;
                animation-delay: 1s;
            }
            &:nth-child(6) {
                animation: showbox 1.2s forwards;
                animation-delay: 1.2s;
            }
        }
    }
    .box {
        margin: 0 auto .2rem;
        width: 16.86rem;
        height: .34rem;
        display: flex;
        overflow: hidden;
        transform: translateX(0.215rem);
        background: url(../../assets/zh/2-1/box_bg.png) 0 0 / 100% 100% no-repeat;
        position: relative;
        .target {
            width: .33rem;
            height: .33rem;
            background: url(../../assets/zh/2-1/target.png) 0 0/ 100% 100% no-repeat;
            position: absolute;
            top: 0;
            z-index: 10;
            opacity: 0;
            &.active {
                animation: showreward 1.2s forwards; 
            }
            &:nth-of-type(1) {
                left: 1.28rem;
                animation-delay: .2;
            }
            &:nth-of-type(2) {
                left: 4.05rem;
                animation-delay: .4s;
            }
            &:nth-of-type(3) {
                left: 6.86rem;
                animation-delay: .6s;
            }
            &:nth-of-type(4) {
                left: 9.63rem;
                animation-delay: .8s;
            }
            &:nth-of-type(5) {
                left: 12.39rem;
                animation-delay: 1s;
            }
            &:nth-of-type(6) {
                left: 15.17rem;
                animation-delay: 1.2s;
            }
        }
        .line {
            width: 17.72rem;
            height: 1.8rem;
            background: url(../../assets/zh/2-1/progress.png) 0 0/ 100% 100% no-repeat;
            position: absolute;
            top: -0.73rem;
            left: -17.72rem;
            z-index: 9;
        }
    }
    .reward_area {
        margin: 0 auto;
        width: 16.12rem;
        position: relative;
        .reward_item {
            z-index: 10;
            position: absolute;
            top: .1rem;
            width: 2.22rem;
            height: 3.29rem;
            background: url(../../assets/zh/2-1/reward_selected.png) center center / 100% 100% no-repeat;
            opacity: 0;
            &.active {
                animation: showreward 1.2s forwards;   
                &:nth-of-type(1) {
                    left: 0.2rem;
                    animation-delay: .2;
                }
                &:nth-of-type(2) {
                    left: 2.96rem;
                    animation-delay: .4s;
                }
                &:nth-of-type(3) {
                    left: 5.74rem;
                    animation-delay: .6s;
                }
                &:nth-of-type(4) {
                    right: 5.39rem;
                    animation-delay: .8s;
                }   
                &:nth-of-type(5) {
                    right: 2.62rem;
                    animation-delay: 1s;
                }
                &:nth-of-type(6) {
                    right: -0.15rem;
                    animation-delay: 1.2s;
                }
            }
        }
    }
    .rewards {
        display: block;
        width: 16.44rem;
        height: auto;
        margin: 0 auto;
    }
    .wap_reward {
        display: none;
    }
    .ljyy {
        margin: .6rem auto 0;
        width: 4.16rem;
        height: .88rem;
        line-height: .76rem;
        text-align: center;
        font-size: .3rem;
        user-select: none;
        cursor: pointer;
        background: url(../../assets/zh/2-1/yybtn-bg.png) 0 0 / 100% 100% no-repeat;
        -webkit-tap-highlight-color: transparent;
        color: #B04B30;
        font-weight: 700;
        &:active {
            transform: scale(0.98);
        }
        &.en,
        &.in,
        &.fi {
            font-size: .22rem;
        }
    }
}


@keyframes showbox2 {
    0% {
        color: #686868;
        border: 1px solid #686868;
    }
    100% {
        color: #e4bd51;
        border: 1px solid #e4bd51;
    }
}
@keyframes showreward {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
@keyframes line2ml {
    0% {
        margin-left: -1rem;
    }
    100% {
        margin-left: -0.02rem;
    }
}

@media screen and (max-width: 751px) {
    .section2 {
        background: url(../../assets/wap/zh/2-1/bg.png) center center / cover no-repeat;
        justify-content: flex-start;
        padding-top: 1.4rem;
        .tit {
            width: 7.4rem;
            height: 1.27rem;
            margin-bottom: 0.1rem;
            .img1 {
                display: none;
            }
            .img2 {
                height: .42rem;
                max-width: 100%;
                margin-top: .5rem;
            }
        }
        .people {
            width: 5.49rem;
            height: .56rem;
            font-size: .3rem;
            margin-bottom: 0;
            display: flex;
            align-items: flex-end;
            justify-content: center;
            i {
                font-style: normal;
                margin-right: 0.05rem;
                font-size: .63rem;
                height: .85rem;
            }
        }
        .progress {
            display: none;
        }
        .reward_area {
            display: none;
        }
        .box {
            display: none;
        }
        .wapbox {
            position: absolute;
            left: 50%;
            transform: translateX(-1.2rem);
            top: 0;
            width: .37rem;
            height: 8.04rem;
            background: url(../../assets/wap/zh/2-1/progress.png) 0 0 / 100% 100% no-repeat;
            overflow: hidden;
            .target {
                width: .33rem;
                height: .33rem;
                background: url(../../assets/zh/2-1/target.png) 0 0/ 100% 100% no-repeat;
                z-index: 10;
                position: absolute;
                left: 0.025rem;
                opacity: 0;
                &.active {
                    animation: showreward 1.2s forwards; 
                }
                &:nth-of-type(1) {
                    animation-delay: .2;
                    bottom: .56rem;
                }
                &:nth-of-type(2) {
                    animation-delay: .4s;
                    bottom: 1.88rem;
                }
                &:nth-of-type(3) {
                    animation-delay: .6s;
                    bottom: 3.2rem;
                }
                &:nth-of-type(4) {
                    animation-delay: .8s;
                    bottom: 4.52rem;
                }
                &:nth-of-type(5) {
                    animation-delay: 1s;
                    bottom: 5.84rem;
                }
                &:nth-of-type(6) {
                    animation-delay: 1.2s;
                    bottom: 7.16rem;
                }
            }
            .line {
                position: absolute;
                bottom: -8.36rem;
                left: 0;
                width: 8.36rem;
                height: 1.84rem;
                background: url(../../assets/zh/2-1/progress.png) 0 0/ 100% 100% no-repeat;
                z-index: 9;
                transform: translate(0.185rem,0.85rem) rotate(-90deg);
                transform-origin: 0 center;
            }
        }
        .wap_reward {
            width: 5.6rem;
            height: 8.5rem;
            display: block;
            margin: 0.4rem auto 0.2rem;
            position: relative;
            .rewards_img {
                height: 8.22rem;
                width: auto;
                position: absolute;
                right: 0;
            }
            .wap_progress {
                position: absolute;
                top: 0;
                width: 100%;
                z-index: 2;
                .progress-bar {
                    transform: translateY(0.28rem);
                }
                .select_img {
                    position: absolute;
                    top: 0;
                    right: 0.22rem;
                    width: 50%;
                    height: auto;
                    opacity: 0;
                }
                &:nth-child(1) {
                    top: 79.9%;
                }
                &:nth-child(2) {
                    top: 64.5%;
                }
                &:nth-child(3) {
                    top: 48.5%;
                }
                &:nth-child(4) {
                    top: 32.7%;
                }
                &:nth-child(5) {
                    top: 17.5%;
                }
                &:nth-child(6) {
                    top: 2%;
                }
                &.active {
                    &:nth-child(1) {
                        span {
                            animation: showbox2 1.2s forwards;
                            animation-delay: .2s;
                        }
                        .select_img {
                            animation: showreward 1.2s forwards;
                            animation-delay: .2s;
                        }
                    }
                    &:nth-child(2) {
                        span {
                            animation: showbox2 1.2s forwards;
                            animation-delay: .4s;
                        }
                        .select_img {
                            animation: showreward 1.2s forwards;
                            animation-delay: .4s;
                        }
                    }
                    &:nth-child(3) {
                        span {
                            animation: showbox2 1.2s forwards;
                            animation-delay: .6s;
                        }
                        .select_img {
                            animation: showreward 1.2s forwards;
                            animation-delay: .6s;
                        }
                    }
                    &:nth-child(4) {
                        span {
                            animation: showbox2 1.2s forwards;
                            animation-delay: .8s;
                        }
                        .select_img {
                            animation: showreward 1.2s forwards;
                            animation-delay: .8s;
                        }
                    }
                    &:nth-child(5) {
                        span {
                            animation: showbox2 1.2s forwards;
                            animation-delay: 1s;
                        }
                        .select_img {
                            animation: showreward 1.2s forwards;
                            animation-delay: 1s;
                        }
                    }
                    &:nth-child(6) {
                        span {
                            animation: showbox2 1.2s forwards;
                            animation-delay: 1.2s;
                        }
                        .select_img {
                            animation: showreward 1.2s forwards;
                            animation-delay: 1.2s;
                        }
                    } 
                }
            }
        }
        .ljyy {
            margin-top: -0.2rem;
        }
    }
}
</style>